<template>
  <md-card>
    <md-card-header>
      <div class="md-layout">
        <div class="md-layout-item md-size-100">
          <h4 class="title">Attachments</h4>
          <p class="category">
            Supporting Documents associated with the Customer.
          </p>
        </div>
      </div>
    </md-card-header>
    <md-card-content>
      <div class="md-layout-item md-small-size-100 md-size-100">
        <template v-if="attachments.length">
          <div
            v-for="attachment in attachments"
            :key="attachment.id"
            class="md-layout attachments"
          >
            <div class="md-layout-item md-size-70 attachment-title">
              <h6>{{ attachment.filename }}</h6>
            </div>
            <div
              class="md-layout-item md-size-30 attachment-actions text-right"
            >
              Delete | Download
            </div>
            <div class="md-layout-item md-size-100 attachment-description">
              {{ attachment.description }}
            </div>
          </div>
        </template>
        <md-empty-state
          v-else
          md-label="Supporting Documents"
          md-description="No files have been added to the account"
        >
          <!-- <md-button class="md-primary md-raised">Attach a file</md-button> -->
        </md-empty-state>
      </div>
    </md-card-content>
  </md-card>
</template>
<script>
import customerApi from "@/services/api/customer";

export default {
  props: {
    customer: Object
  },

  data() {
    return {
      attachments: []
    };
  },

  components: {},

  methods: {
    getAttachments() {
      customerApi.getAttachments(this.customer).then(resp => {
        this.attachments = resp.data;
      });
    }
  },

  computed: {},

  created() {},

  beforeMount() {
    this.getAttachments();
  },

  mounted() {}
};
</script>
<style lang="scss" scoped>
.attachment-title h6 {
  margin: 0;
}
</style>
